import * as validBrands from './brands';
export default function isValidBrand(brand) {
  if (brand && brand !== '' && !Object.values(validBrands).includes(brand)) {
    const message = `Invalid brand ${brand} passed to BrandContext Provider`;
    // eslint-disable-next-line no-console
    console.log(message);
    if (typeof window !== 'undefined' && window?.newrelic?.addPageAction) {
      window.newrelic.addPageAction('ValidBrandCheck', {
        brand,
        component: 'isValidBrand',
        currentUrl: window.location.pathname,
        message
      });
    }
  }
}